export enum EStorageKey {
  AUTHDATA = '0',
  ACCOUNT = '1',
  SETTINGS = '2',
  LOGS = '3',
}
